
<div class="site-panel w-100" v-if="tzb" style="position: relative">
    <p-site-tzb-history
        :unit     = "site"
        :current  = "tzb"
        :history  = "history.items"
        v-model   = "history.show"
        @selected = "onSelected"
    />

    <p-site-tzb-reports
        v-model   = "reports.show"
        :menu     = "reports.items"
        @selected = "onPrint"
    />

    <v-row class="no-frame">
        <v-col class="main-first-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-elevator-general
                    :data     = "tzb"
                    :readonly = "readonly"
                    :extended = "extended"
                />
            </v-row>

            <v-row class="no-frame mt-5">
                <c-site-tzb-elevator-maintenance
                    :data          = "tzb.maintenance"
                    :zus-inspection = "tzb.zusInspection"
                    :readonly       = "readonly"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-elevator-gadget
                    :title  = "$t('unit.tzb.engine.title')"
                    :label  = "$t('unit.tzb.engine.label')"
                    :gadget = "tzb.engine"
                    :extended = "extended"
                    :readonly = "readonly"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-middlle-col no-border" style="padding-right: 1px">
            <v-row class="no-frame mt-2">
                <c-site-tzb-elevator-gadget
                    :title  = "$t('unit.tzb.automatic.title')"
                    :label  = "$t('unit.tzb.automatic.label')"
                    :gadget = "tzb.automatic"
                    :extended = "extended"
                    :readonly = "readonly"
                >
                    <template v-slot:additional>
                        <v-row class="no-frame mt-1">
                            <f-read-only-field
                                :value        = "site.specification.collectiveControlType ? site.specification.collectiveControlType.name : '---' "
                                :label        = "$t('unit.tzb.automatic.subtitle')"
                                class         = "w-100"
                                :line  = "false"
                                dense
                            />
                        </v-row>
                    </template>
                </c-site-tzb-elevator-gadget>
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-elevator-gadget
                    :title  = "$t('unit.tzb.control.title')"
                    :label  = "$t('unit.tzb.control.label')"
                    :gadget   = "tzb.control"
                    :extended = "extended"
                    :readonly = "readonly"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-elevator-gadget
                    :title  = "$t('unit.tzb.manholeDoor.title')"
                    :label  = "$t('unit.tzb.manholeDoor.label')"
                    :gadget = "tzb.liftShaftDoor"
                    :extended = "extended"
                    :readonly = "readonly"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-middlle-col no-border">
            <v-row class="no-frame mt-2">
                <v-col class="no-frame col-12">
                    <c-site-tzb-car
                        :data="tzb.car"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-5">
                <v-col class="no-frame col-12">
                    <c-site-tzb-elevator-gadget
                        :title    = "$t('unit.tzb.speedLimiter.title')"
                        :label    = "$t('unit.tzb.speedLimiter.label')"
                        :sublabel = "$t('unit.tzb.speedLimiter.sublabel')"
                        :gadget   = "tzb.speedLimiter"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-5">
                <v-col class="no-frame col-12">
                    <c-site-tzb-elevator-gadget
                        :title  = "$t('unit.tzb.saftyCatch.title')"
                        :label  = "$t('unit.tzb.saftyCatch.label')"
                        :gadget = "tzb.saftyCatch"
                        :extended = "extended"
                        :readonly = "readonly"
                    />
                </v-col>
            </v-row>
            <c-v-spacer />
        </v-col>
        <v-col class="main-last-col no-border">
            <v-row class="no-frame mt-2">
                <c-site-tzb-elevator-gadget
                    :title    = "$t('unit.tzb.doorDrive.title')"
                    :label    = "$t('unit.tzb.doorDrive.label')"
                    :sublabel = "$t('unit.tzb.doorDrive.sublabel')"
                    :gadget   = "tzb.doorDrive"
                    :extended = "extended"
                    :readonly = "readonly"
                />
            </v-row>
            <v-row class="no-frame mt-5">
                <c-site-tzb-elevator-gadget
                    :title  = "$t('unit.tzb.emcSystem.title')"
                    :label  = "$t('unit.tzb.emcSystem.label')"
                    :gadget = "tzb.emcSystem"
                    :extended = "extended"
                    :readonly = "readonly"
                />
            </v-row>
            <c-v-spacer />
        </v-col>
    </v-row>
</div>
